import { h } from '@stencil/core';
import { triggerTrackEvent } from 'utils/events';
import { initCarouselWithThumbs } from 'utils/carousel';
import galleryModal from 'store/galleryModal';
import Swiper from 'swiper';

let swiperInstances: [Swiper, Swiper];

const onClose = () => {
  galleryModal.isOpen = false;

  triggerTrackEvent({
    event_type: 'user',
    event_name: 'close_gallery',
  });
};

const onKeyDown = event => {
  const [thumbs, swiperInstance] = swiperInstances;

  if (event.key === 'ArrowRight') {
    event.preventDefault();

    if (!swiperInstance.isEnd) {
      triggerTrackEvent({
        event_type: 'user',
        event_name: 'gallery_next_image_keyboard',
      });
    }

    swiperInstance.slideNext();
  } else if (event.key === 'ArrowLeft') {
    event.preventDefault();

    if (!swiperInstance.isBeginning) {
      triggerTrackEvent({
        event_type: 'user',
        event_name: 'gallery_prev_image_keyboard',
      });
    }

    swiperInstance.slidePrev();
  } else if (event.key === 'Escape') {
    triggerTrackEvent({
      event_type: 'user',
      event_name: 'gallery_close_keyboard',
    });
    event.preventDefault();
    onClose();
  }
};

export default function GalleryModal({ show }: { show: boolean }) {
  requestAnimationFrame(() => {
    if (show) {
      swiperInstances = initCarouselWithThumbs(document.getElementById('swiper-container-main'), document.getElementById('swiper-container-thumb'));
    }

    document[show ? 'addEventListener' : 'removeEventListener']('keydown', onKeyDown);
  });

  return show ? (
    <div id="gallery-modal" role="presentation" class="eva-3-modal -show-sticky-footer fullscreen-modal -close-icon-white -show-modal">
      <div role="presentation" class="modal-header transparent-modal">
        <i class="eva-3-icon-cross modal-close -eva-3-mr-md" role="button" tabindex="0" aria-label="Close modal" onClick={() => onClose()} />
      </div>
      <div role="presentation" class="modal-content transparent-modal">
        <div id="swiper-container-main" class="swiper-container">
          <div class="swiper">
            <div class="swiper-wrapper">
              {galleryModal.images.map(image => (
                <img class="swiper-slide" src={image.url} alt="Image" />
              ))}
            </div>
          </div>
        </div>
        <div id="swiper-container-thumb" class="swiper-container">
          <div class="swiper">
            <div class="swiper-wrapper">
              {galleryModal.images.map(image => (
                <img class="swiper-slide" src={image.url.concat('/120x75?op=TRUNCATE&enlarge=false')} alt="Thumb image" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
